import { Injectable } from '@angular/core';
import { UsuarioBc } from '../model/usuario-bc';

@Injectable()
export class StorageService {
  public static readonly OBJ_LOGIN_BC = 'OBJ_LOGIN_BC';
  public static readonly TOKEN_BC = 'TOKEN_BC';
  public static readonly USER_BC = 'USER_BC';
  public static readonly TOKEN_SCAB = 'TOKEN_SCAB';
  public static readonly CURRENT_APP = 'CURRENT_APP';
  public static readonly TOKEN_BARRAMENTO = 'TOKEN_BARRAMENTO';


  constructor() {
  }

  setObjLogin(objLogin) {
    localStorage.setItem(StorageService.OBJ_LOGIN_BC, JSON.stringify(objLogin));
  }

  getObjLogin() {
    return this.getItemJson(StorageService.OBJ_LOGIN_BC);
  }

  setTokenBc(token) {
    localStorage.setItem(StorageService.TOKEN_BC, token);
  }

  getTokenBc() {
    return this.getItem(StorageService.TOKEN_BC);
  }

  setCurrentApp(app) {
    localStorage.setItem(StorageService.CURRENT_APP, app);
  }

  getCurrentApp() {
    return this.getItem(StorageService.CURRENT_APP);
  }


  setUserBc(userBc: UsuarioBc) {
    if (userBc) {
      userBc.dataLogin = new Date();
    }
    localStorage.setItem(StorageService.USER_BC, userBc ? JSON.stringify(userBc) : null);
  }

  getUserBc() {
    return this.getItemJson(StorageService.USER_BC);
  }

  setTokenScab(token) {
    localStorage.setItem(StorageService.TOKEN_SCAB, token);
  }

  setTokenBarramento(token) {
    localStorage.setItem(StorageService.TOKEN_BARRAMENTO, token);
  }

  getTokenScab() {
    return this.getItem(StorageService.TOKEN_SCAB);
  }

  getTokenBarramento() {
    return this.getItem(StorageService.TOKEN_BARRAMENTO);
  }



  private getItemJson(item) {
    const result = localStorage.getItem(item);
    return result ? JSON.parse(result) : null;
  }

  private getItem(item) {
    return localStorage.getItem(item);
  }

  setFlagTokensProcessados(value: boolean): void {
    localStorage.setItem('tokens_bc_processados', value.toString());
  }

  getFlagTokensProcessados(): boolean {
    return localStorage.getItem('tokens_bc_processados') === 'true';
  }

// No logout/reseta tudo
  clearFlagTokensProcessados(): void {
    localStorage.removeItem('tokens_bc_processados');
  }

  clearAll(): void {
    localStorage.clear();
  }
}



// WEBPACK FOOTER //
// ./src/app/services/storage.service.ts